import script from "./BeneficiarySelector.vue?vue&type=script&setup=true&lang=js"
export * from "./BeneficiarySelector.vue?vue&type=script&setup=true&lang=js"

import "./BeneficiarySelector.vue?vue&type=style&index=0&id=50fc137a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50fc137a"]])

export default __exports__